export const error = state => state.error
export const isLoading = state => state.isLoading
export function retrieved (state) {
  if (state.retrieved.firm && typeof state.retrieved.firm === 'object') {
    state.retrieved.firm = state.retrieved.firm['@id']
  }
  if (state.retrieved.contractor && typeof state.retrieved.contractor === 'object') {
    state.retrieved.contractor = state.retrieved.contractor['@id']
  }
  if (state.retrieved.idCase && typeof state.retrieved.idCase === 'object') {
    state.retrieved.idCase = state.retrieved.idCase['@id']
  }
  if (state.retrieved.positions.length > 0) {
    state.retrieved.positions.forEach(entry => {
      if (typeof entry.item === 'object') entry.item = entry.item['@id']
    })
  }
  state.retrieved.orderTags = state.retrieved.orderTags.map(entry => {
    if (entry.tag && entry.tag.tag) {
      return { '@id': entry['@id'], value: entry.tag['@id'], text: entry.tag.tag }
    } else {
      return { '@id': entry['@id'], value: entry.value, text: entry.text }
    }
  })
  return state.retrieved
}
export const updated = state => state.updated
export const violations = state => state.violations
